import * as ents from '@attain-apps/entities'
import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import * as transformers from '@attain-apps/transformers'
import { TypeAsserter } from '@attain-apps/type-guards'
import gql from 'graphql-tag'

export const DOC = gql`
  fragment FragmentMosaicAction on MosaicAction {
    id
    alias
    name
    query
    description
  }
`
export const TRANSFORMER = graphql.transformers.OUT.object<
  graphql.schema.FragmentMosaicActionFragment,
  ents.core.mosaic.Action
>({
  alias: graphql.transformers.OUT.validate(
    transformers.PASS_THROUGH,
    TypeAsserter.assertIsNotNullish,
    { warnOnly: true },
  ),
  description: transformers.PASS_THROUGH,
  id: transformers.PASS_THROUGH,
  name: graphql.transformers.OUT.default(transformers.PASS_THROUGH, ''),
  query: graphql.transformers.OUT.validate(
    graphql.transformers.OUT.json({ onNullish: 'preserve' }),
    ents.core.mosaic.Action.Query.assertIsQuery,
    { warnOnly: true },
  ),
})
